import ZigZagSection from './ZigZagSection'

export default ZigZagSection